interface Font {
    variant: string
}

export default class FontResolver {
    private readonly name: string
    private font?: Font
    private readonly meta: { [key: string]: Font } = {
        'Roboto': {
            variant: 'sans-serif',
        },
        'Open Sans': {
            variant: 'sans-serif',
        },
        'Lato': {
            variant: 'sans-serif',
        },
        'Montserrat': {
            variant: 'sans-serif',
        },
        'Oswald': {
            variant: 'sans-serif',
        },
        'Raleway': {
            variant: 'sans-serif',
        },
        'Noto Sans': {
            variant: 'sans-serif',
        },
        'Fira Sans': {
            variant: 'sans-serif',
        },
        'Lora': {
            variant: 'serif',
        },
        'Merriweather': {
            variant: 'serif',
        },
        'Libre Baskerville': {
            variant: 'serif',
        }
    }

    constructor(name: string) {
        this.name = name

        if (this.meta[name] === undefined) {
            throw new Error('Font not supported.')
        }

        this.font = this.meta[name]
    }

    getCssFontFamily(): string {
        return `'${this.name}', ${this.font!.variant}`
    }
}
